import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC, useState } from "react";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";
import { Contact } from "@hostingbv/lib/src/api/common/models/Contact";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const DeleteCustomerContactModal: FC<{ customer: Customer; contact: Contact }> = ({ customer, contact }) => {
  const { partnerClient } = useApiClient(config);
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!;
  const [error, setError] = useState("");

  // ModalFooter refreshes and closes once this resolves, so wait until the contact is actually deleted.
  const confirm = async () => {
    if (contact === null) return;
    setError("");
    const result = await partnerClient.deleteCustomerContact(customer.id, contact.id);
    if (!result.success) {
      setError(result.error);
      throw new Error(result.error);
    }
    // Deployments without an entity are only listed with tenant scope, so with own scope the deployment never shows
    // up. Stop waiting after a while and refresh anyway.
    const deployment = await Promise.race([
      awaitNextDeploymentFinished(result.data.id),
      new Promise<null>((resolve) => setTimeout(() => resolve(null), 10_000)),
    ]);
    if (deployment?.status === "failed") {
      // @ts-expect-error output is untyped
      setError(deployment.output?.message ?? "Could not delete the contact");
      throw new Error("deployment failed");
    }
  };

  return (
    <div>
      <p className={""}>
        <strong>Caution!</strong> You are about to delete the contact <strong>{contact.email}</strong>
      </p>
      {error.length > 0 && <div className={"font-medium text-red-600"}>{error}</div>}
      <ModalFooter icon={faTrash} text={"Delete"} onSubmit={confirm} />
    </div>
  );
};
